import axios from '@/plugins/axios'

const getAudiences = async ({
  advertiserId,
  type,
  category,
  page = 1,
  search = null,
  isActive = null
}) => {
  try {
    const params = {
      page: page,
      search: search,
      is_active: isActive
    }

    if (type) params.type = type
    if (category) params.category = category

    const response = await axios.get('admin/audiences', {
      params: params
    })
    const { data } = response
    return data
  } catch (error) {
    return Promise.reject(error)
  }
}

/**
 * upload file chunk
 */
const uploadFileChunk = async ({ fileId, chunk, chunkIndex, totalChunks, fileName }) => {
  try {
    const formData = new FormData()
    formData.append('file', chunk)
    formData.append('file_id', fileId)
    formData.append('chunk_index', chunkIndex)
    formData.append('total_chunks', totalChunks)
    formData.append('file_name', fileName)

    const response = await axios.post('admin/file-chunks', formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    })

    const { data } = response
    return data
  } catch (error) {
    return Promise.reject(error)
  }
}

const upsertAudiences = async ({
  file,
  // eslint-disable-next-line camelcase
  type_import
}) => {
  const form = new FormData()
  form.append('file', file)
  form.append('type_import', type_import)

  try {
    const response = await axios.post('admin/audiences', form, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    })
    const { data } = response
    return data
  } catch (error) {
    return Promise.reject(error)
  }
}

export default {
  getAudiences,
  uploadFileChunk,
  upsertAudiences
}
